/**************************************************
 * Nombre:       Apartado_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {Check} from "@mui/icons-material";
import {VideoNoAdalantable} from "../Componentes/VideoNoAdalantable";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Uno from "../Dialogos/Dialogo_Uno";
import Dialogo_Dos from "../Dialogos/Dialogo_Dos";
import Dialogo_Tres from "../Dialogos/Dialogo_Tres";
import {activate} from "video-react/lib/actions/player";

const Apartado_Portada = ({termino, setTermino, actual, datosFunnel, realizado}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Uno,
        titulo: 'Dejanos saber tus impresiones',
        realizado: realizado
    })
    const {Dialogo: DialogoDos, abrir: abrirDos} = useDialogo({
        Componente: Dialogo_Dos,
        titulo: 'Que preguntas te surgen?',
        realizado: realizado
    })
    const {Dialogo: DialogoTres, abrir: abrirTres} = useDialogo({
        Componente: Dialogo_Tres,
        titulo: 'Terminaste!',
        realizado: realizado
    })

    const abrirDialogo = () => {


        switch (actual.numero) {
            case 1 :
                abrir({nombreFunnel: datosFunnel.titulo})
                break
            case 2 :
                abrirDos({nombreFunnel: datosFunnel.titulo, id: actual.id})
                break
            case 3 :
                abrirTres({nombreFunnel: datosFunnel.titulo, id: actual.id})
                break
            default:
                abrir({nombreFunnel: datosFunnel.titulo})


        }

    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography
                    sx={{
                        fontWeight: 600,
                        textAlign: 'center',
                        fontSize: sCell ? 16 : 18,
                        lineHeight: 1.2,
                        color: '#00000050'
                    }}>
                    {`${actual.numero ? actual.numero : ''} de 3`}
                </Typography>
            </Grid>

            <Dialogo/>

            <DialogoDos/>

            <DialogoTres/>

            <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{fontWeight: 600, textAlign: 'center', fontSize: sCell ? 18 : 24, lineHeight: 1.2}}>
                    {actual.titulo}
                </Typography>
            </Grid>

            {/*  <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    startIcon={<PlayArrow/>}
                    sx={{
                        borderRadius: 8,
                        background: 'linear-gradient(90deg, rgba(144, 73, 245, 0.40) 0%, rgba(122, 28, 255, 0.40) 50%, rgba(57, 232, 255, 0.40) 100%)',
                        boxShadow: 0,
                        color: '#5D20B7',
                        opacity: 0.4
                    }}
                >
                    Quiero ser contactado
                </Button>
            </Grid> */}

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                <VideoNoAdalantable
                    setTermino={setTermino}
                    url={actual.video}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 6}}>
                <Typography sx={{fontWeight: 400, textAlign: 'center', lineHeight: 1.1, fontSize: 14}}>
                    Termina este video antes de continuar con el siguiente, esto te dara mejores resultados
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    onClick={() => abrirDialogo()}
                    startIcon={<Check/>}
                    disabled={!termino}
                    sx={{
                        background: !termino ? "#00000080" : 'linear-gradient(90deg, #9049F5 0%, #7A1CFF 51.44%, #39E8FF 100%)',
                        fontWeight: 500,
                        px: 4,
                        py: 1.5
                    }}
                >
                    {termino ? 'Continuar' : `Termina el video de ${actual.tiempo} Min`}

                </Button>
            </Grid>

        </Grid>
    )

}
export default Apartado_Portada